import { queryOptions, useQuery } from "@tanstack/react-query";
import { retrieveRawInitData } from "@tma.js/sdk-react";

export type User = {
  id: string;
  created_at: string;
  customer_id?: string | undefined;
  subscription: "default" | "standard";
  first_name: string;
  last_name: string;
  photo_url: string;
  telegram_id: 162647720;
  username: string;
};

export type AuthLoginResponse = {
  user: User;
  token: string;
};

export const useAuthLoginQueryOptions = () => {
  return queryOptions({
    queryFn: async () => {
      const initData = retrieveRawInitData();
      const response = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/auth/login`,
        {
          headers: {
            Authorization: `tma ${initData}`,
          },
        }
      );
      if (!response.ok) {
        const data: { message: string } = await response.json();
        throw new Error(data.message);
      }

      const data: AuthLoginResponse = await response.json();

      return data;
    },
    queryKey: ["auth", "login"],
  });
};

export const useAuthLoginQuery = () => {
  return useQuery(useAuthLoginQueryOptions());
};
